import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ExerciseTemplateForm from '../../../components/forms/ExerciseTemplateForm';
import { useExerciseTemplateApi } from '../../../hooks/useExerciseTemplateApi';
import { useNavigate } from 'react-router-dom';
import { ExerciseTemplateDTO } from '../../../services/apiClient';

const ExerciseTemplateCreate: React.FC = () => {
  const { create, isLoading } = useExerciseTemplateApi();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Exercise Templates', href: '/admin/exercisetemplates' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: ExerciseTemplateDTO) => {
    try {
      setIsSubmitting(true);
      await create(data);
      navigate('/admin/exercisetemplates');
    } catch (error) {
      console.error('Error creating ExerciseTemplate:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/exercisetemplates"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.ExerciseTemplate.Edit"
    >
      <ExerciseTemplateForm
        initialValues={{} as ExerciseTemplateDTO}
        onSubmit={handleSubmit}
        onCancel={() => navigate('/admin/exercisetemplates')}
        isLoading={isSubmitting}
      />
    </AdminLayout>
  );
};

export default ExerciseTemplateCreate;
